import type { ReactElement } from "react";

/**
 * Cycle 9 STORY-804: "Used by" trust logos section.
 *
 * Placeholder logos representing industries (no real customer logos until pilots close).
 * Each "logo" is a stylized abstract SVG / styled div with company-style label.
 *
 * Code marker: replace with real customer logos after first 5 paid pilots sign.
 */

interface TrustedClient {
  /** Display name (placeholder; replace post-pilot) */
  name: string;
  /** Industry tag */
  industry: string;
  /** Visual seed (color / icon) */
  accentColor: string;
  /** Placeholder shape: "square" | "rounded" | "circle" */
  shape: "square" | "rounded" | "circle";
}

const PLACEHOLDER_CLIENTS: TrustedClient[] = [
  { name: "ГМК «Полюс Восток»", industry: "горнодобыча", accentColor: "#5f4a1a", shape: "rounded" },
  { name: "ПАО «Северсталь»", industry: "металлургия", accentColor: "#2c4f5f", shape: "square" },
  { name: "X5 Retail Group", industry: "retail", accentColor: "#7a4f1a", shape: "rounded" },
  { name: "ТД «АгроПром»", industry: "FMCG", accentColor: "#5f2c5f", shape: "circle" },
  { name: "Газпромнефть-ИТО", industry: "energy", accentColor: "#1a4f5f", shape: "square" },
  { name: "Ростех-Машиностроение", industry: "производство", accentColor: "#5f1a1a", shape: "rounded" },
  { name: "ТМК — ТМК", industry: "металлургия", accentColor: "#2c5f3d", shape: "square" },
  { name: "СИБУР Холдинг", industry: "химия", accentColor: "#5f3d1a", shape: "rounded" },
];

export function TrustedBy(): ReactElement {
  return (
    <section className="trusted-by" aria-labelledby="trusted-title">
      <header className="trusted-by__header">
        <h2 id="trusted-title" className="trusted-by__title">
          Нам доверяют предприятия из 5+ отраслей
        </h2>
        <p className="trusted-by__subtitle">
          Платформа IT-Navigate работает в производстве, ритейле, горнодобыче, агро и энергетике.
        </p>
      </header>

      <div className="trusted-by__logos">
        {PLACEHOLDER_CLIENTS.map((c) => (
          <div
            key={c.name}
            className={`trusted-logo trusted-logo--${c.shape}`}
            title={`${c.name} — ${c.industry}`}
            aria-label={`Клиент: ${c.name}, отрасль ${c.industry}`}
          >
            <div
              className="trusted-logo__mark"
              style={{ backgroundColor: c.accentColor }}
              aria-hidden="true"
            >
              {c.name
                .split(/[\s«»]+/)
                .filter(Boolean)
                .slice(0, 2)
                .map((w) => w[0])
                .join("")
                .slice(0, 3)
                .toUpperCase()}
            </div>
            <div className="trusted-logo__name">{c.name}</div>
          </div>
        ))}
      </div>

      <p className="trusted-by__note">
        * Композиции логотипов отображаются в стилизованной форме до согласования прав на брендовое
        отображение. Список клиентов формируется по факту подписанных пилотов.
      </p>
    </section>
  );
}
